import { render } from "./CameraStreaming.vue?vue&type=template&id=4bae7ab7"
import script from "./CameraStreaming.vue?vue&type=script&lang=js"
export * from "./CameraStreaming.vue?vue&type=script&lang=js"

import "./CameraStreaming.vue?vue&type=style&index=0&id=4bae7ab7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__